export class Pools {
  Data: Pool[];
  Count: number;
}

export class Pool {
  Id?: number;
  Name?: string;
  Comment?: string;
  CreatedOn?: Date;
  Type?: 'User' | 'Project';
  User?: {Id: number; Account: string; FirstName: string; LastName: string};
  Creator?: string;
  VisibleFor?: number | {
    SC?: boolean;
    CO?: boolean;
    CT?: boolean;
  };
  IsPublic?: boolean;
  Count?: number;
  Faults?: number[];
  LocalCount?: number;
}
